(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1623],{

/***/ 95112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var shared_gtm_onBeginCheckout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21538);





var ActionButton = function(param) {
    var klassId = param.klassId, disabled = param.disabled, handler = param.handler, name = param.name, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, course = param.course;
    var className = !isMobile ? "flex justify-center items-center w-full mt-4 py-2.5 px-14 rounded \n      ".concat(disabled ? "bg-gray-300 cursor-not-allowed" : "bg-primary-normal") : "flex-1 block rounded-md font-semibold text-center py-2 text-white ".concat(disabled ? "bg-gray-300 cursor-not-allowed" : "bg-primary-normal");
    var actionHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (klassId.includes("kdt")) {
            react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer({
                dataLayer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    event: "kdt_apply_btn_click",
                    content_ids: klassId
                }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
            });
        }
        if (course && [
            "event",
            "worker"
        ].includes(course.courseType)) {
            (0,shared_gtm_onBeginCheckout__WEBPACK_IMPORTED_MODULE_3__/* .onBeginCheckout */ .C)(course);
        }
        handler();
    }, [
        course,
        handler,
        klassId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        disabled: disabled,
        onClick: actionHandler,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "text-base font-semibold text-white md:text-lg",
            children: name
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActionButton);


/***/ }),

/***/ 91251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67804);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_sec2time__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76002);




var KlassInfoSection = function(param) {
    var course = param.course, isKDT = param.isKDT, isSimplifyKDT = param.isSimplifyKDT, isDelayCourse = param.isDelayCourse, isPreNoticeStatus = param.isPreNoticeStatus, applyStatus = param.applyStatus, applyPeriodList = param.applyPeriodList;
    var weeks = course.weeks, startedAt = course.startedAt, endedAt = course.endedAt, totalResources = course.totalResources, totalSeconds = course.totalSeconds, isOffline = course.isOffline, level = course.level, flags = course.flags, courseType = course.courseType;
    var isStartUp = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return courseType === "kdt_startup";
    }, [
        courseType
    ]);
    var courseWeek = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return weeks ? weeks >= 52 ? "1년" : "".concat(weeks, "주") : "";
    }, [
        weeks
    ]);
    var getEduType = function(klassType) {
        if (klassType === "kdt" || klassType === "kdt_plus" || klassType === "kdt_startup") {
            if (flags.includes("onoffline")) {
                return "온라인 / 오프라인";
            }
            if (flags.includes("online")) {
                return "온라인";
            }
            if (flags.includes("offline")) {
                return "오프라인";
            }
        } else {
            return isOffline ? "오프라인" : "온라인 VOD";
        }
        return "온라인";
    };
    var detailInfoList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ClockIcon */ .T39, {
                    className: "h-5 w-5"
                }),
                title: isKDT ? "강의분량" : "수업분량",
                content: isKDT && totalSeconds ? "".concat((0,_utils_sec2time__WEBPACK_IMPORTED_MODULE_3__/* .getCourseTotalTime */ .$)(totalSeconds), " (약 ").concat(isStartUp ? "7" : "8", "시간/일)") : totalResources && totalSeconds && totalResources > 0 && totalSeconds > 0 ? "총 ".concat(totalResources, "개 수업").concat(isDelayCourse ? "" : " ∙ ".concat((0,_utils_sec2time__WEBPACK_IMPORTED_MODULE_3__/* .getCourseTotalTime */ .$)(totalSeconds))) : ""
            },
            {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .HomeIcon */ .tvw, {
                    className: "h-5 w-5"
                }),
                title: "수강방식",
                content: getEduType(courseType)
            },
            {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .CalendarIcon */ .Que, {
                    className: "h-5 w-5"
                }),
                title: "수강기간",
                content: (endedAt === null || endedAt === void 0 ? void 0 : endedAt.includes("9998")) ? "평생 소장" : "".concat(courseWeek).concat(isDelayCourse ? " ∙ 영상 순차 공개" : "")
            }, 
        ];
    }, [
        course,
        isKDT
    ]);
    console.log(detailInfoList);
    var renderKlassDetailInfoList = function(infoList) {
        return infoList.map(function(param, idx) {
            var icon = param.icon, title = param.title, content = param.content;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: "flex items-center text-sm ".concat(isKDT && idx === 3 && [
                    "ing",
                    "end"
                ].includes(applyStatus) ? "hidden" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "inline-flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "ml-2 min-w-12.5 font-semibold",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-2 whitespace-nowrap",
                        children: content
                    })
                ]
            }, "".concat(title, "_").concat(idx));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex flex-col space-y-3",
        children: renderKlassDetailInfoList(detailInfoList)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KlassInfoSection);


/***/ }),

/***/ 21538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ onBeginCheckout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7316);



// GA 향상된 전자상거래 - enhanced ecommerce
// GA4 전자상거래 - ecommerce
var onBeginCheckout = function(course) {
    react_gtm_module__WEBPACK_IMPORTED_MODULE_0___default().dataLayer({
        dataLayer: {
            ecommerce: null
        }
    });
    react_gtm_module__WEBPACK_IMPORTED_MODULE_0___default().dataLayer({
        dataLayer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            event: "begin_checkout",
            ecommerce: {
                items: [
                    (0,utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_1__/* .convertToEcommerceItem */ .Gn)(course)
                ]
            }
        }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
    });
};


/***/ }),

/***/ 89123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_WithHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(67804);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Footer/Footer.module.scss
var Footer_module = __webpack_require__(52836);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/Footer/index.tsx







var FooterSection = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xs text-neutral",
                children: title
            }),
            children
        ]
    });
};
var iconList = [
    {
        name: "Instagram",
        icon: "/svg/icon_instagram.svg",
        href: "https://www.instagram.com/likelion.official/"
    },
    {
        name: "Youtube",
        icon: "/svg/icon_youtube.svg",
        href: "https://www.youtube.com/channel/UCYaDkwVaOhuoe_LuFr3lWkA"
    },
    {
        name: "KakaoTalk",
        icon: "/svg/icon_kakaoch.svg",
        href: "https://pf.kakao.com/_iyUBM"
    },
    {
        name: "Brunch",
        icon: "/svg/icon_brunch.svg",
        href: "https://brunch.co.kr/@likelion"
    },
    {
        name: "Facebook",
        icon: "/svg/icon_facebook.svg",
        href: "https://www.facebook.com/likelion.net"
    }, 
];
var Footer = function() {
    var router = (0,next_router.useRouter)();
    var goToMain = (0,react.useCallback)(function() {
        return router.push("/").then(function() {
            return window.scrollTo(0, 0);
        });
    }, [
        router
    ]);
    var KlassList = [
        {
            title: "전체 강의",
            href: "/catalog"
        },
        {
            title: "국비지원 부트캠프",
            href: "".concat(window.bootcampDomain, "?utm_source=likelion&utm_medium=likelion_home&utm_campaign=likelion_home"),
            target: "_blank",
            rel: "noopener noreferrer"
        },
        {
            title: "이벤트",
            href: "/event"
        },
        {
            title: "기업 문의",
            href: "/enterprise"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "border-t border-normal bg-white",
        style: {
            minWidth: 320
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl px-4 py-8 xl:px-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col md:flex-row md:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative h-4 w-[145.45px] cursor-pointer md:h-7 md:w-[175px]",
                            onClick: goToMain,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/img/likelion_kor_black_logo_renew.svg",
                                alt: "likelion",
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6 flex flex-col space-y-6 md:mt-0 md:flex-row md:space-x-20 md:space-y-0 xl:space-x-28",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                    title: "모든 교육 경험",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "mt-4 space-y-3",
                                        children: KlassList.map(function(param, idx) {
                                            var title = param.title, href = param.href, target = param.target, rel = param.rel;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm font-semibold",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: href,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: target,
                                                        rel: rel,
                                                        children: title
                                                    })
                                                })
                                            }, "".concat(title, "_").concat(idx));
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                    title: "회사 소개",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "mt-3 flex flex-col gap-y-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center gap-x-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://likelion.career.greetinghr.com",
                                                        target: "_blank",
                                                        className: "flex items-center text-sm font-semibold",
                                                        rel: "noreferrer noopener",
                                                        children: "브랜드 웹사이트"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ExternalLinkIcon */.h0n, {
                                                        className: "w-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center gap-x-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://likelion.notion.site/LIKELION-BRAND-GUIDELINE-942a09c286b1401b83f9193c0787759e",
                                                        target: "_blank",
                                                        className: "flex items-center text-sm font-semibold",
                                                        rel: "noreferrer noopener",
                                                        children: "브랜드 가이드라인"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ExternalLinkIcon */.h0n, {
                                                        className: "w-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center gap-x-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://likelion.career.greetinghr.com/career",
                                                        target: "_blank",
                                                        className: "flex items-center text-sm font-semibold",
                                                        rel: "noreferrer noopener",
                                                        children: "채용"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ExternalLinkIcon */.h0n, {
                                                        className: "w-6"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "mt-5 w-full border-normal lg:mt-8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "mb-6 flex space-x-3",
                            children: iconList.map(function(param) {
                                var name = param.name, icon = param.icon, href = param.href;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: href,
                                        rel: "noreferrer noopener",
                                        className: "flex h-7 w-7 items-center lg:h-6 lg:w-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: icon,
                                            alt: name,
                                            className: "h-6 w-6"
                                        })
                                    })
                                }, name);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center space-x-2 text-xs font-medium",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://likelion.notion.site/LIKELION-89ba1354b98d4825af14109aebdd3af9",
                                    className: "text-neutral",
                                    target: "_blank",
                                    rel: "noopener noreferrer nofollow",
                                    children: "이용약관"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "h-1 w-1 rounded-full bg-gray-500"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://likelion.notion.site/LIKELION-4d3c7ce22a724b3c99950e853dc7589b",
                                    className: "text-neutral",
                                    target: "_blank",
                                    rel: "noopener noreferrer nofollow",
                                    children: "개인정보처리방침"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "h-1 w-1 rounded-full bg-gray-500"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://likelion.notion.site/LIKELION-e9139bf291ad4e0b88f8b99f8597d04a",
                                    className: "text-neutral",
                                    target: "_blank",
                                    rel: "noopener noreferrer nofollow",
                                    children: "환불규정"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-0.5 md:flex-row md:space-y-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-xs text-neutral",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Footer_module_default()).corp,
                                                    children: "상호명: 멋쟁이사자처럼"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Footer_module_default()).corp,
                                                    children: "대표: 나성영"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Footer_module_default()).corp,
                                                    children: "contact@likelion.net"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex text-[10px] text-neutral md:text-xs",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Footer_module_default()).corp,
                                                    children: "사업자 번호 : 264-88-01106"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "통신판매업 신고번호 : 2022-서울종로-1534"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-0.5 flex flex-col space-y-0.5 text-[10px] text-neutral md:mt-1 md:flex-row md:space-x-2 md:space-y-0 md:text-xs",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "주소 : 서울 종로구 종로3길17, 광화문D타워 D1동 16층, 17층"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Copyright \xa9 2022 멋쟁이사자처럼 All rights reserved."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./components/Header/index.tsx + 6 modules
var Header = __webpack_require__(13881);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./shared/contexts/Auth.tsx
var Auth = __webpack_require__(96759);
;// CONCATENATED MODULE: ./shared/layout/WithHeader/index.tsx





var WithHeader = function(param) {
    var children = param.children, _kdcDetailPage = param.kdcDetailPage, kdcDetailPage = _kdcDetailPage === void 0 ? false : _kdcDetailPage;
    var ref = (0,Auth/* useAuth */.a)(), isSigned = ref.isSigned, signInUrl = ref.signInUrl, profile = ref.profile;
    var state = lib_default().stringify({
        state: location.pathname
    });
    var signInUrlWithState = "".concat(signInUrl, "&").concat(state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    isSigned: isSigned,
                    signInUrl: signInUrlWithState,
                    profile: profile
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1",
                    children: children
                }),
                !kdcDetailPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
                })
            ]
        })
    });
};
/* harmony default export */ var layout_WithHeader = (WithHeader);


/***/ }),

/***/ 52836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"corp":"Footer_corp__NtB7b","logoImg":"Footer_logoImg__igjNX"};

/***/ })

}]);